<template>
  <!-- <AddButton btnid='' name="Add New" class=" float-rights " v-if="showButton" @click="IsCreate()">
        Add New
    </AddButton>
    <EditIcon v-if="!showButton" @click="IsEditpop()">Edit</EditIcon> -->
  <Dialog
    v-model:visible="showDialog"
    :modal="true"
    :header="model ? $t('DeliveryTerms.Edittitle') : $t('DeliveryTerms.title')"
    :breakpoints="{ '960px': '75vw', '640px': '90vw' }"
    :style="{ width: '40vw' }"
    @after-hide="IsClear"
  >
    <!-- <Loader :loading="loading" /> -->
    <div>
      <b-form @submit.prevent="IsSubmit">
        <b-row>
          <b-col lg="6" md="6" sm="6" cols="12">
            <div class="field">
              <TextField
                :required-icon="true"
                id="code"
                name="code"
                :label="$t('DeliveryTerms.code')"
                :rules="{ required: true }"
                :disabled="true"
                v-model="deliveryTermsform.DeliTermsCode"
                placeholder=" "
              />
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="field">
              <Textarea
                :required-icon="true"
                id="Delivery description"
                name="Delivery description"
                :label="$t('DeliveryTerms.desc')"
                :rules="{ required: true }"
                v-model="deliveryTermsform.DeliTermsDesc"
                placeholder=" "
                :autofocus="true"
              />
            </div>
          </b-col>
        </b-row>
        <Footer
          @cancel="(showDialog = false), IsClear()"
          :cancelhide="false"
          :label="label"
          :loading="Saveloading"
        />
      </b-form>
    </div>
  </Dialog>
  <CreateSuccessfully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, h, onMounted } from "vue";
import Footer from "../../../../../../components/FormComponents/Footer.vue";
import DeliveryTermsService from "../../../../../../modules/Inventory/Service/DeliveryTermsService";
import TextField from "../../../../../../components/FormComponents/TextInput.vue";
import Textarea from "../../../../../../components/FormComponents/TextArea.vue";
import common from "../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessfully from "../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import AlreadyExist from "../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";

export default defineComponent({
  props: {
    selectedItem: {
      type: Object,
      Default: () => {},
    },
    showButton: {
      type: Boolean,
      Required: true,
    },
    OperationID: {
      type: Object,
      default: {},
    },
    EntityId: {
      type: Number,
      default: 0,
    },
  },
  components: {
    Footer,
    TextField,
    Textarea,
    CreateSuccessfully,
    UpdatedSuccessfully,
    EditConfirmation,
    AlreadyExist,
  },
  setup(props, { emit }) {
    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    // let Entitydata = ref();
    // Entitydata.value = localStorage.getItem("EntityData");
    // Entitydata.value = JSON.parse(Entitydata.value);
    let Entitydata = ref({
      EntityId: 0,
    });
    Entitydata.value.EntityId = props.EntityId;
    const successpop = ref(false);
    const updatepop = ref(false);
    const Editmodel = ref(false);
    const alreadyexistpop = ref(false);
    const { t } = useI18n();
    const label = ref(t("btn.save"));
    const loading = ref(false);
    let Saveloading = ref(false);
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const showDialog = ref();
    const model: any = ref(props.selectedItem);
    if (model.value != null) {
      IsEdit();
    } else {
      IsCreate();
    }
    function IsCreate() {
      showDialog.value = true;
      GetCode();
    }
    //update and create jsonrequest
    const deliveryTermsform = ref({
      CreatedAt: "",
      CreatedBy: 0,
      ModifiedBy: 0,
      ModifiedAt: "",
      HospitalId: 0,
      BranchId: 0,
      Id: 0,
      DeliTermsCode: "",
      DeliTermsDesc: "",
      EntityId: 0,
      EntityOperationId: 0,
    });

    //findone function
    async function IsEdit() {
      showDialog.value = true;
      // loading.value = true;
      emit("loadershow");
      try {
        label.value = t("btn.update");
        let Id = model.value.Id;
        const response = await DeliveryTermsService.getfindonedata(Id);
        let data = response["result"];
        // loading.value = false;
        emit("loaderhide");
        Object.keys(deliveryTermsform.value).forEach((key) => {
          if (data[key]) deliveryTermsform.value[key] = data[key];
        });
        Editmodel.value = false;
        // loading.value = false;
        emit("loaderhide");
      } catch (error) {
        // loading.value = false;
        emit("loaderhide");
        alert(error);
      }
    }
    async function GetCode() {
      debugger;
      let data = {
        //FormId: 11,
        EntityId: Entitydata.value.EntityId,
        HospitalId: HospitalId,
        BranchId: BranchId,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      deliveryTermsform.value.DeliTermsCode = result;
    }
    //update and create function
    const IsSubmit = async () => {
      Saveloading.value = true;
      emit("loadershow");

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloading.value = false;
        return;
      }

      try {
        deliveryTermsform.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        deliveryTermsform.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        deliveryTermsform.value.BranchId = 0;
        deliveryTermsform.value.HospitalId = HospitalId;
        deliveryTermsform.value.ModifiedBy = UserId;
        deliveryTermsform.value.CreatedBy = UserId;
        deliveryTermsform.value.EntityId = Number(Entitydata.value.EntityId);
        if (deliveryTermsform.value.Id != 0) {
          deliveryTermsform.value.EntityOperationId =
            props.OperationID.UpdateId;
          const response = await DeliveryTermsService.updatedata(
            deliveryTermsform.value
          );
          console.log(response.data);
          let message = response["ErrorInfo"].ErrorCode;
          // loading.value = false;
          emit("loaderhide");
          if (message == null && response["result"] == "Already") {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;
            updatepop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        } else {
          deliveryTermsform.value.EntityOperationId =
            props.OperationID.CreateId;
          const response = await DeliveryTermsService.createdata(
            deliveryTermsform.value
          );
          console.log(response.data);
          let message = response["ErrorInfo"].ErrorCode;
          // loading.value = false;
          emit("loaderhide");
          if (message == null && response["result"] == "Already") {
            Saveloading.value = false;
            alreadyexistpop.value = true;
          } else if (message == null) {
            Saveloading.value = false;
            successpop.value = true;
          } else {
            Saveloading.value = false;
            alert("something went wrong");
          }
        }
      } catch (error) {
        alert(error);
        Saveloading.value = false;
      }
    };
    //IsClear data function
    const copydataModel = JSON.parse(JSON.stringify(deliveryTermsform.value));
    const IsClear = () => {
      Object.assign(deliveryTermsform.value, copydataModel);
      // deliveryTermsform.value.Id = 0
      // deliveryTermsform.value.DeliTermsDesc = ''
      // deliveryTermsform.value.DeliTermsCode = ''
      emit("update:selectedItem", undefined);
      emit("close");
    };
    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
    });
    let isSubmitCalled = false;
    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "s") {
        if (!isSubmitCalled) {
          isSubmitCalled = true;
          IsSubmit();
        }
      } else if (
        (event.altKey && event.key == "c") ||
        (event.key == "Escape" &&
          successpop.value == false &&
          updatepop.value == false)
      ) {
        IsClear();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Created Sucessfully Popup-Close
    function closetrigger() {
      successpop.value = false;
      updatepop.value = false;
      emit("load");
      IsClear();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      deliveryTermsform.value.DeliTermsDesc = "";
    }

    return {
      model,
      closetrigger,
      Editmodel,
      updatepop,
      successpop,
      IsCreate,
      showDialog,
      deliveryTermsform,
      IsEdit,
      IsSubmit,
      IsClear,
      alreadyexistpop,
      alreadyclosetrigger,
      label,
      loading,
      Saveloading,
    };
  },
});
</script>
